import { z } from 'zod';
import { AUDIT_ACTORS } from '../enums';
import { jsonValueSchema, paginationQuerySchema, uuidSchema } from './common';

/** Audit log (API_DOCS.md — Settings, Stats, Audit). Every mutation writes one row. */

export const auditEntrySchema = z.object({
  id: uuidSchema,
  actor: z.enum(AUDIT_ACTORS),
  action: z.string(),
  entity: z.string().nullable(),
  entityId: z.string().nullable(),
  before: jsonValueSchema.nullable(),
  after: jsonValueSchema.nullable(),
  ip: z.string().nullable(),
  createdAt: z.string().datetime(),
});
export type AuditEntry = z.infer<typeof auditEntrySchema>;

export const auditQuerySchema = paginationQuerySchema.extend({
  actor: z.enum(AUDIT_ACTORS).optional(),
  action: z.string().optional(),
});
export type AuditQuery = z.infer<typeof auditQuerySchema>;
